var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable prettier/prettier */
/**
 * 我的联系人列表
 */
import React, { useEffect, useMemo } from 'react';
import { Empty, List } from 'antd';
import UserSelectionContext from '../context';
import { useLoadingProps } from '../hooks';
import { useGetListItem } from './TabPaneList';
import Loading from '../../Loading';
import { groupListItem, LetterHeader, selectContactTypeListItem } from '../common';
export default function ContactsList(props) {
    var _this = this;
    var _a = React.useContext(UserSelectionContext), businessTab = _a.businessTab, currentUser = _a.currentUser, dataListFilter = _a.dataListFilter, contactShowType = _a.contactShowType;
    var result = props.result, onItemCheck = props.onItemCheck, onGetExternalContacts = props.onGetExternalContacts, tabKey = props.tabKey;
    var _b = React.useState(null), dataList = _b[0], setDataList = _b[1];
    var _c = React.useState(true), loading = _c[0], setLoading = _c[1];
    var loadDataList = React.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var data, list, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (tabKey !== 'externalContacts') {
                        setDataList([]);
                        return [2 /*return*/];
                    }
                    if (!onGetExternalContacts) {
                        setDataList([]);
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, onGetExternalContacts()];
                case 2:
                    data = _a.sent();
                    list = selectContactTypeListItem(contactShowType, data, currentUser);
                    // const list = contactsListData(contactsFilterFlag, data, currentUser)
                    if (dataListFilter) {
                        list = list.filter(dataListFilter);
                    }
                    setDataList(list);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1);
                    setDataList([]);
                    return [3 /*break*/, 4];
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [tabKey, onGetExternalContacts, contactShowType, currentUser, dataListFilter]);
    var loadingProps = useLoadingProps(dataList);
    useEffect(function () {
        loadDataList().then();
    }, [loadDataList]);
    var getListItem = useGetListItem({ result: result, onItemCheck: onItemCheck });
    var letterItemsMap = useMemo(function () {
        if (!dataList || (dataList || []).length === 0) {
            return {};
        }
        return groupListItem(dataList.filter(function (item) { return item.name; }));
    }, [dataList]);
    if (loading) {
        return React.createElement(Loading, { style: { height: '100%' } });
    }
    return (React.createElement("div", { className: "contacts-container" }, (dataList || []).length === 0 ? (React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u6682\u65E0\u6570\u636E" })) : (React.createElement("div", { className: "contacts-list" }, Object.keys(letterItemsMap).length > 0 &&
        Object.keys(letterItemsMap).map(function (letter, index) {
            return (React.createElement("div", { key: letter },
                React.createElement(LetterHeader, { title: letter }),
                React.createElement(List, { loading: loadingProps, dataSource: letterItemsMap[letter] || [], renderItem: function (item) { return getListItem(item); } })));
        })))));
}
//# sourceMappingURL=ContactsList.js.map